/**
 *  @class
 *  @function SocialShare
 */
if (!customElements.get('social-share')) {
  class SocialShare extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.links = document.querySelectorAll('.social:not(.clipboard)');

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          let left = (screen.width / 2) - (640 / 2),
            top = (screen.height / 2) - (440 / 2) - 100;
          window.open(link.getAttribute('href'), 'mywin', 'left=' + left + ',top=' + top + ',width=640,height=440,toolbar=0');
          event.preventDefault();
        });
      });
      
      // 初始化Clipboard功能
      if (typeof ClipboardJS !== 'undefined') {
        const clipboardBtns = document.querySelectorAll('.clipboard');
        
        if (clipboardBtns.length) {
          const clipboard = new ClipboardJS('.clipboard', {
            text: function() {
              return window.location.href;
            }
          });
          
          clipboard.on('success', function(e) {
            const clipboardBubble = e.trigger.querySelector('.clipboard--bubble');
            
            if (clipboardBubble) {
              clipboardBubble.classList.add('is-visible');
              
              setTimeout(() => {
                clipboardBubble.classList.remove('is-visible');
              }, 2000);
            }
          });
        }
      }
    }
  }
  customElements.define('social-share', SocialShare);
}